import { useParams } from "react-router-dom";
import "./index.css";
import { useEffect, useState } from "react";
import VideoPlayer from "../VideoPlayer/videoplayer";

const GoogleDocViewer = () => {
  const { id } = useParams();
  const [user] = useState(JSON.parse(localStorage.getItem("student")));
  const [docData, setDocData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSheet = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/api/get-sheet-data`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id, course: user.student.program }),
          },
        );

        if (!response.ok) throw new Error("Failed to fetch document");

        const result = await response.json();
        setDocData(result.data);
      } catch (e) {
        console.error("Error fetching doc:", e);
      } finally {
        setLoading(false);
      }
    };

    fetchSheet();
  }, [id]);

  return (
    <div className="doc-container">
      <h1>Coding Practice Guidance Video</h1>
      <VideoPlayer />

      {loading && <p>Loading document…</p>}
      {!loading && docData && (
        <div className="doc-frame-container">
          <h2>Session Resources</h2>
          <iframe
            src={`${docData}/preview`}
            width="100% !important"
            height="100%"
            title="Google Document Viewer"
            allowFullScreen
          ></iframe>{" "}
        </div>
      )}
      {!loading && !docData && <p>Document not found</p>}
    </div>
  );
};

export default GoogleDocViewer;
